import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    color: #ccc;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { lighten } from 'polished';
import { transitionSpeed } from './animation';
import { white, poppyRed, mineShaft } from './colors';
import checkIcon from '../assets/images/check-icon.svg';
import errorIcon from '../assets/images/error-icon.svg';
import dropdownArrow from '../assets/images/dropdown-arrow.svg';
var darkInputTextColor = white;
var darkInputBackground = lighten(0.02, mineShaft);
var darkInputBackgroundFocus = mineShaft;
var darkInputBorderDefault = 'none';
var darkInputErrorColor = poppyRed;
var darkInputLabelColor = white;
var darkInputPadding = '1rem';
export var darkInputHeight = '2.5em';

function placeholder() {
  return "\n  &::-webkit-input-placeholder {\n    ".concat(css.apply(void 0, arguments), "\n  }\n  &:-moz-placeholder {\n    ").concat(css.apply(void 0, arguments), "\n  }\n  &::-moz-placeholder {\n    ").concat(css.apply(void 0, arguments), "\n  }\n  &:-ms-input-placeholder {\n    ").concat(css.apply(void 0, arguments), "\n  }");
}

export var darkLabel = "\n  color: ".concat(darkInputLabelColor, ";\n  margin-bottom: 0.5em;\n  font-weight: 600;\n  line-height: 1.375em;\n");
export var darkInputError = "\n  &, &:focus {\n    border-color: ".concat(darkInputErrorColor, ";\n  }\n");
export var darkBase = "\n  color: ".concat(darkInputTextColor, ";\n  width: 100%;\n  border-width: 2px;\n  border-style: solid;\n  padding: 0 ").concat(darkInputPadding, ";\n  transition: background-color ").concat(transitionSpeed, ", border-color ").concat(transitionSpeed, ";\n  background-color: ").concat(darkInputBackground, ";\n  border-color: transparent;\n\n  &:hover {\n    background-color: ").concat(lighten(0.02, darkInputBackground), ";\n  }\n  &:focus {\n    outline: none;\n    border-color: ").concat(darkInputBorderDefault, ";\n    background-color: ").concat(darkInputBackgroundFocus, ";\n  }\n");
export var darkInputBase = "\n  ".concat(darkBase, "\n  height: ").concat(darkInputHeight, ";\n  line-height: ").concat(darkInputHeight, ";\n  border-radius: 4px;\n  ").concat(placeholder(_templateObject()), "\n");
export var validBackgroundImage = "\n  background-image: url(".concat(checkIcon, ");\n");
export var errorBackgroundImage = "\n  background-image: url(".concat(errorIcon, ");\n");
export var dropdownArrowBackgroundImage = "\n  background-image: url(".concat(dropdownArrow, ");\n");